import React from 'react';
import { Box } from '@material-ui/core';

const BorderLine = ({ color, ...rest }) => {
  return <Box border={0.5} borderColor={color} {...rest} />;
};
export default BorderLine;
